import R from "../europe/ewm";

export default R
